import { gql } from '@apollo/client'

export const setSettingMutation = gql`
  mutation setSetting($input: SetSettingAppSettingServiceArgs!) {
    setSetting(input: $input) {
      _id
      key
      value
    }
  }
`
